import { render, staticRenderFns } from "./EzChangeEmail.vue?vue&type=template&id=30e6fb64&"
import script from "./EzChangeEmail.vue?vue&type=script&lang=js&"
export * from "./EzChangeEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports